import { notification } from '@/lib/notifications';
import { getTranslation } from '@/lib/utils/i18n';

// `onQueryStarted: notifyOnSuccess('KEY')` — the success notification fires from the data layer.
export const notifyOnSuccess =
  (labelKey) =>
  async (arg, { queryFulfilled }) => {
    try {
      await queryFulfilled;
      notification.success(getTranslation(labelKey));
    } catch {
      // notifyApiErrors reports it.
    }
  };
